import { ListItem, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { If } from "lib/@components/if"

export function LegislationSchedulesPopoverItem({ item }) {
    return (
        <ListItem sx={{ py: 0.75, px: 2 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ width: 1 }}>
                <Iconify
                    icon="mdi:file-document-outline"
                    sx={{ width: 18, height: 18, flexShrink: 0, color: "text.secondary" }}
                />
                <Stack sx={{ flex: 1, minWidth: 0 }}>
                    <TruncatedTypography sx={{ fontSize: 14 }}>{item?.title}</TruncatedTypography>
                    <If truthy={item?.code}>
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                            #{item?.code}
                        </Typography>
                    </If>
                </Stack>
                <If truthy={item?.version}>
                    <Typography variant="caption" sx={{ color: "text.disabled", flexShrink: 0 }}>
                        V{item?.version}
                    </Typography>
                </If>
            </Stack>
        </ListItem>
    )
}
